<template>
  <section class="legend-wrapper">
    <div @click="showLegend = !showLegend" class="legend">
      <div>{{ $t('color-legend') }}</div>
    </div>
    <div class="open-legend flex-column" v-if="showLegend">
      <div class="title">{{ $t('color-legend') }}:</div>
      <!-- <div class="subtitle">{{ $t(legend.dialTitle) }}</div>
      <div :class="['dials', item.color]" v-for="item in legend.dials" :key="item.color">
        <span>{{ $t(item.text) }}</span>
      </div>
      <div class="subtitle">{{ $t(legend.pillarTitle) }}</div>
      <div class="pillars" v-for="item in legend.pillars" :key="item.color">
        <div class="Performance">
          <Performance :class="item.color" />
        </div>
        <span>{{ $t(item.text) }}</span>
      </div>
      <div class="subtitle">{{ $t(legend.tabTitle) }}</div> -->
      <div :class="['tabs', item.color]" v-for="item in legend.tabs" :key="item.color">
        <span>{{ $t(item.text) }}</span>
      </div>
    </div>
  </section>
</template>

<script>
// import Performance from '@/assets/new/icon_performance.svg';
import legend from '@/utils/legend';

export default {
  name: 'LegendComponent',
  components: {},
  props: {},
  data() {
    return {
      legend: legend(),
      showLegend: false,
    };
  },
  created() {},
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.legend-wrapper {
  z-index: 2;
  width: 100%;
  justify-content: flex-end;
  display: flex;
  position: sticky;
  bottom: 0;
}
.title {
  font-size: 20px;
  margin-bottom: 20px;
}
.subtitle {
  font-size: 16px;
  margin-bottom: 20px;
  margin-top: 10px;
}
.legend {
  width: 135px;
  display: flex;
  position: sticky;
  text-align: left;
  height: 40px !important;
  padding: 0 0 0 15px !important;
  cursor: pointer;
  color: #000;
  background: #ffffff;
  display: flex;
  align-items: center;
  border: 1px solid #898c8d;
  position: relative;
  &::after {
    content: '';
    background-image: url('../assets/icons/carrot_up.svg?external');
    background-repeat: no-repeat;
    background-size: 16px 8px;
    width: 16px;
    height: 8px;
    transition: transform 100ms;
    margin: 10px;
  }
  &.open::after {
    transform: rotate(180deg);
  }
  span {
    vertical-align: middle;
  }
}
.open-legend {
  position: absolute;
  bottom: 41px;
  border: 1px solid #898c8d;
  background: white;
  overflow: auto;
  padding: 40px;
  text-align: left;
  color: black;
  // height: 500px;
  overflow: auto;
}
.dials {
  display: flex;
  margin-bottom: 10px;
  span {
    display: flex;
    align-items: center;
  }
  &::before {
    border-radius: 50px;
    font-size: 14px;
    height: 15px;
    width: 15px;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    content: '';
    align-items: center;
  }
}
.gray {
  &::before {
    border: 8px solid #8a8c8d;
  }
}
.black {
  &::before {
    border: 8px solid #000000;
  }
}
.orange {
  &::before {
    border: 8px solid $fca-orange;
  }
}
.green {
  &::before {
    border: 8px solid #038717;
  }
}
.red {
  &::before {
    border: 8px solid #eb0001;
  }
}
.light-gray {
  &::before {
    border: 8px solid #c4c5c6;
  }
}
.blue {
  &::before {
    border: 8px solid #597dd9;
  }
}
.yellow {
  &::before {
    border: 8px solid #e4bd35;
  }
}
.dark-blue {
  &::before {
    border: 8px solid #6d20be;
  }
}
.light-red {
  &::before {
    border: 8px solid #ff6261;
  }
}
.pillars {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.Performance {
  svg {
    min-width: 30px !important;
    height: 30px !important;
    padding: 0;
    margin-left: -5px;
    filter: drop-shadow(0px 3px 6px #00000029);
    &.gray {
      g {
        circle {
          fill: #8a8c8d;
        }
      }
    }
    &.green {
      g {
        circle {
          fill: #038717;
        }
      }
    }
    &.red {
      g {
        circle {
          fill: #eb0001;
        }
      }
    }
  }
}
.tabs {
  display: flex;
  margin-bottom: 10px;
  span {
    display: flex;
    align-items: center;
  }
  &::before {
    border-radius: 50px;
    font-size: 14px;
    height: 15px;
    width: 15px;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    content: '';
    align-items: center;
  }
  // &.green {
  //   &::before {
  //     background: #038717;
  //   }
  // }
  // &.red {
  //   &::before {
  //     background: #eb0001;
  //   }
  // }
  &.gray {
    &::before {
      background: #8a8c8d;
    }
  }
  &.black {
    &::before {
      background: #000000;
    }
  }
  &.orange {
    &::before {
      background: $fca-orange;
    }
  }
  &.green {
    &::before {
      background: #038717;
    }
  }
  &.red {
    &::before {
      background: #eb0001;
    }
  }
  &.light-gray {
    &::before {
      background: #c4c5c6;
    }
  }
  &.blue {
    &::before {
      background: #597dd9;
    }
  }
  &.yellow {
    &::before {
      background: #e4bd35;
    }
  }
  &.dark-blue {
    &::before {
      background: #6d20be;
    }
  }
  &.light-red {
    &::before {
      background: #ff6261;
    }
  }
}
</style>
